import React from 'react';
import Styles from '../styles/components/ServiceViewer.module.css';

const ServiceViewer = ({ service }) => {
    if (!service) {
        return <p className={Styles.placeholder}>No service selected.</p>;
    }

    return (
        <div className={Styles.container}>
            <h2 className={Styles.heading}>Service Details</h2>
            <table className={Styles.table}>
                <tbody>
                <tr>
                    <th>Service ID:</th>
                    <td>{service.service_id}</td>
                </tr>
                <tr>
                    <th>Date:</th>
                    <td>{service.service_date}</td>
                </tr>
                <tr>
                    <th>Notes:</th>
                    <td>{service.notes || '—'}</td>
                </tr>
                <tr>
                    <th>Communion:</th>
                    <td>{service.communion ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <th>Hymn Leader:</th>
                    <td>{service.hymn_leader || '—'}</td>
                </tr>
                <tr>
                    <th>Created At:</th>
                    <td>{service.created_at}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};

export default ServiceViewer;
